// eslint-disable-next-line no-empty-pattern
const ActiveHEvKAProjects = ({ }) => {
    return <div style={{
        border: "2px solid #BBBBBB", borderRadius: "24px",
        backgroundColor: "#E7F7F0", padding: "10px 10px 10px 20px"
    }}>
        <table className={"HomePageNavigationTable"}>
            <tbody className="leftAlignedCell">
                <tr><td><h2>Active HEvKA Projects</h2></td></tr>
                <tr><td><a href="/resources/List/437652"><h3>AI-structured Clinical Trial Eligibility Criteria</h3></a></td></tr>
                <tr><td><a href="/resources/List/396954"><h3>Eligibility Criteria Examples</h3></a></td></tr>
                <tr><td><a href="/resources/Composition/397022"><h3>Evidence Based Medicine (EBM) Implementation Guide</h3></a></td></tr>
                <tr><td><a href="/resources/Library/396955"><h3>Formula Building with KaTeX</h3></a></td></tr>
                <tr><td><a href="/resources/CodeSystem/27833"><h3>GRADE Ontology</h3></a></td></tr>
                <tr><td><a href="/resources/Composition/397094"><h3>Making Guidelines Computable</h3></a></td></tr>
                <tr><td><a href="/resources/Composition/397123"><h3>Measuring the Rate of Scientific Knowledge Transfer</h3></a></td></tr>
                <tr><td><a href="/resources/Composition/27845"><h3>Scientific Evidence Code System (SEVCO)</h3></a></td></tr>
                <tr><td><a href="/resources/Composition/397472"><h3>Setting the Scientific Record on FHIR</h3></a></td></tr>
                <tr><td><a href="/resources/Composition/397476"><h3>StudyRegistryRecord Profile Working Group</h3></a></td></tr>
            </tbody>
        </table>
    </div>
}

export default ActiveHEvKAProjects;